import AddressBook from './AddressBook';
import AddressBookTitleBar from './AddressBookTitleBar';
import EmptyStateTeam from './EmptyStateTeam';
import EmptyStatePhysicians from './EmptyStatePhysicians';
import EmptyStatePatients from './EmptyStatePatients';
import EmptyStatePatientsInvited from './EmptyStatePatientsInvited';
import EmptyStateGroups from './EmptyStateGroups';
import EmptyStateAll from './EmptyStateAll';
import EmptyStateArchive from './EmptyStateArchive';
import InvitationButton from './InvitationButton';

AddressBook.TitleBar = AddressBookTitleBar;
AddressBook.EmptyStateTeam = EmptyStateTeam;
AddressBook.EmptyStatePhysicians = EmptyStatePhysicians;
AddressBook.EmptyStatePatients = EmptyStatePatients;
AddressBook.EmptyStatePatientsInvited = EmptyStatePatientsInvited;
AddressBook.EmptyStateAll = EmptyStateAll;
AddressBook.EmptyStateGroups = EmptyStateGroups;
AddressBook.EmptyStateArchive = EmptyStateArchive;
AddressBook.InvitationButton = InvitationButton;

export default AddressBook;
